import { render, staticRenderFns } from "./secretarias.vue?vue&type=template&id=f02182a2&"
import script from "./secretarias.vue?vue&type=script&lang=ts&"
export * from "./secretarias.vue?vue&type=script&lang=ts&"
import style0 from "./secretarias.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports